module.exports = __webpack_public_path__ + "img/cp-library.11100a07.svg";